import { VersionChangeIndicator } from "./VersionChangeIndicator";
import { usePreviewPrintVersionQuery } from "../hooks/usePreviewPrintVersionQuery";
import { NextVersion } from "../types/version_management_types";
import { shortSoftwareVersion } from "../utils/version_management_utils";

export interface CompanyVersionChangeIndicatorProps {
    currentVersion?: string;
    currentTagId?: number;
    nextVersion?: NextVersion;
}

export function CompanyVersionChangeIndicator({
    currentVersion,
    currentTagId,
    nextVersion,
}: CompanyVersionChangeIndicatorProps) {
    const { loading, error, data } = usePreviewPrintVersionQuery(
        nextVersion?.updateStrategy,
        nextVersion?.tagId
    );

    const currentVersionText = shortSoftwareVersion(currentVersion);

    let nextVersionText;
    if (nextVersion !== undefined && nextVersion.tagId !== currentTagId) {
        nextVersionText = shortSoftwareVersion(data?.getPreviewPrintVersion?.productVersion);
    }

    return (
        <VersionChangeIndicator
            currentVersion={currentVersionText}
            isLoadingNextVersion={loading}
            errorNextVersion={error?.message}
            nextVersion={nextVersionText}
        />
    );
}
